// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*Page Section of about Page*/
.page-section {
    display: flex; 
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    padding: 50px 20px;
    background-color: #f8f8f8;
    gap: 30px;
  }
  .About-header {
    text-align: left;
    margin-left: 5%;
    margin-bottom: -60px;
    font-size: 2rem;
    font-weight: bold;
    
  }
/*images of about page*/
  .img1
  {
    margin-top: 40px;
    margin-left: 5px;
  }
  .img2
  {
    margin-top: 5px;
    margin-left: 5px;
  }
  .img3
  {
    margin-top: 5px;
    margin-right: 5px;
  }
  .img4
  {
    margin-bottom: 5px;
    margin-left: 5px;
  }
  
  /* Create four equal columns that sits next to each other */
  .page-images 
  {
    flex: 25% 1;
    max-width: 25%;
    padding: 5cqw;
  }
  
  .page-images img
   {
    margin-top: 8px;
    vertical-align: middle;
    width: 100%;
  }
  .page-images 
  {
    display: flex;
    justify-content: unset;
    flex-direction:row;
    gap: 20px;
    flex-basis: 50%;
    justify-content: center;
  }
  .page-images img
   {
    width: 100px;
    height: auto;
    border-radius: 5px;
    box-shadow: white;
  }
  .page-text
   {
    flex-basis: 50%;
    max-width: 500px;
    padding: 20px;
    text-align: left;
   
  }

  /*learn more button */ 
  .learn-morebtn
  {
    background-color: #007e01; 
  color: white;
  padding: 10px 20px;
  border-radius: 5px;
  font-weight: bold;
  border: none;
  cursor: pointer;
  display: flex; 
  justify-content: flex-end;
  position: absolute;
   right: 20%;
   bottom: 30%;
  }
  

  .page-text span {
    color: #10677A; /* Orange */
  }
  
  .page-text p {
    margin-top: -20px;
    font-size: 1rem;
    color: 000000;
  }
  .page-text h1 {
    font-size: 2.0rem!important;
    font-weight: bold;
    text-align: left;
    margin-top: -30px;
    background: linear-gradient(90deg, #75C02F, #10677A, #FF4400);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent; /* Ensures only the gradient is visible */
  }
.learn-morebtn
{
  margin-top: 10px;
}



/* Responsive adjustments for smaller screens */
@media (max-width: 768px) {
    .column, .column1, .page-images, .page-text {
      flex: 1 1 100%; /* Columns stack vertically */
      max-width: 100%; /* Take full width */
      
    }
  
    .page-section {
      padding: 90px 10px; /* Smaller padding for mobile */
    }
  
    .page-text h1 {
      font-size: 1.5rem; /* Smaller heading font size */
    }
  
    .page-text p {
      font-size: 0.9rem; /* Smaller paragraph font size */
    }
  
    .page-images img {
      max-width: 80px; 
    }
  }

 
  
/* Responsive adjustments for smaller screens */

  @media (min-width: 1024px) {
    .page-section {
      padding: 60px 30px; 
    }
  
    .column, .column1, .page-images, .page-text {
      flex: 1 1 50%; 
    }
  
    .page-text h1 {
      font-size: 2.5rem; 
    }
  
    .page-images img {
      max-width: 150px; 
    }
  }`, "",{"version":3,"sources":["webpack://./src/components/About/About.css"],"names":[],"mappings":"AAAA,6BAA6B;AAC7B;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,yBAAyB;IACzB,SAAS;EACX;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,eAAe;IACf,iBAAiB;;EAEnB;AACF,uBAAuB;EACrB;;IAEE,gBAAgB;IAChB,gBAAgB;EAClB;EACA;;IAEE,eAAe;IACf,gBAAgB;EAClB;EACA;;IAEE,eAAe;IACf,iBAAiB;EACnB;EACA;;IAEE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA,2DAA2D;EAC3D;;IAEE,WAAS;IACT,cAAc;IACd,aAAa;EACf;;EAEA;;IAEE,eAAe;IACf,sBAAsB;IACtB,WAAW;EACb;EACA;;IAEE,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;IACT,eAAe;IACf,uBAAuB;EACzB;EACA;;IAEE,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;EACnB;EACA;;IAEE,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,gBAAgB;;EAElB;;EAEA,qBAAqB;EACrB;;IAEE,yBAAyB;EAC3B,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,yBAAyB;EACzB,kBAAkB;GACjB,UAAU;GACV,WAAW;EACZ;;;EAGA;IACE,cAAc,EAAE,WAAW;EAC7B;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,aAAa;EACf;EACA;IACE,2BAA2B;IAC3B,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,6DAA6D;IAC7D,6BAA6B;IAC7B,oCAAoC,EAAE,yCAAyC;EACjF;AACF;;EAEE,gBAAgB;AAClB;;;;AAIA,+CAA+C;AAC/C;IACI;MACE,cAAc,EAAE,6BAA6B;MAC7C,eAAe,EAAE,oBAAoB;;IAEvC;;IAEA;MACE,kBAAkB,EAAE,+BAA+B;IACrD;;IAEA;MACE,iBAAiB,EAAE,8BAA8B;IACnD;;IAEA;MACE,iBAAiB,EAAE,gCAAgC;IACrD;;IAEA;MACE,eAAe;IACjB;EACF;;;;AAIF,+CAA+C;;EAE7C;IACE;MACE,kBAAkB;IACpB;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,gBAAgB;IAClB;EACF","sourcesContent":["/*Page Section of about Page*/\n.page-section {\n    display: flex; \n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: center;\n    padding: 50px 20px;\n    background-color: #f8f8f8;\n    gap: 30px;\n  }\n  .About-header {\n    text-align: left;\n    margin-left: 5%;\n    margin-bottom: -60px;\n    font-size: 2rem;\n    font-weight: bold;\n    \n  }\n/*images of about page*/\n  .img1\n  {\n    margin-top: 40px;\n    margin-left: 5px;\n  }\n  .img2\n  {\n    margin-top: 5px;\n    margin-left: 5px;\n  }\n  .img3\n  {\n    margin-top: 5px;\n    margin-right: 5px;\n  }\n  .img4\n  {\n    margin-bottom: 5px;\n    margin-left: 5px;\n  }\n  \n  /* Create four equal columns that sits next to each other */\n  .page-images \n  {\n    flex: 25%;\n    max-width: 25%;\n    padding: 5cqw;\n  }\n  \n  .page-images img\n   {\n    margin-top: 8px;\n    vertical-align: middle;\n    width: 100%;\n  }\n  .page-images \n  {\n    display: flex;\n    justify-content: unset;\n    flex-direction:row;\n    gap: 20px;\n    flex-basis: 50%;\n    justify-content: center;\n  }\n  .page-images img\n   {\n    width: 100px;\n    height: auto;\n    border-radius: 5px;\n    box-shadow: white;\n  }\n  .page-text\n   {\n    flex-basis: 50%;\n    max-width: 500px;\n    padding: 20px;\n    text-align: left;\n   \n  }\n\n  /*learn more button */ \n  .learn-morebtn\n  {\n    background-color: #007e01; \n  color: white;\n  padding: 10px 20px;\n  border-radius: 5px;\n  font-weight: bold;\n  border: none;\n  cursor: pointer;\n  display: flex; \n  justify-content: flex-end;\n  position: absolute;\n   right: 20%;\n   bottom: 30%;\n  }\n  \n\n  .page-text span {\n    color: #10677A; /* Orange */\n  }\n  \n  .page-text p {\n    margin-top: -20px;\n    font-size: 1rem;\n    color: 000000;\n  }\n  .page-text h1 {\n    font-size: 2.0rem!important;\n    font-weight: bold;\n    text-align: left;\n    margin-top: -30px;\n    background: linear-gradient(90deg, #75C02F, #10677A, #FF4400);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent; /* Ensures only the gradient is visible */\n  }\n.learn-morebtn\n{\n  margin-top: 10px;\n}\n\n\n\n/* Responsive adjustments for smaller screens */\n@media (max-width: 768px) {\n    .column, .column1, .page-images, .page-text {\n      flex: 1 1 100%; /* Columns stack vertically */\n      max-width: 100%; /* Take full width */\n      \n    }\n  \n    .page-section {\n      padding: 90px 10px; /* Smaller padding for mobile */\n    }\n  \n    .page-text h1 {\n      font-size: 1.5rem; /* Smaller heading font size */\n    }\n  \n    .page-text p {\n      font-size: 0.9rem; /* Smaller paragraph font size */\n    }\n  \n    .page-images img {\n      max-width: 80px; \n    }\n  }\n\n \n  \n/* Responsive adjustments for smaller screens */\n\n  @media (min-width: 1024px) {\n    .page-section {\n      padding: 60px 30px; \n    }\n  \n    .column, .column1, .page-images, .page-text {\n      flex: 1 1 50%; \n    }\n  \n    .page-text h1 {\n      font-size: 2.5rem; \n    }\n  \n    .page-images img {\n      max-width: 150px; \n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
